import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import Header from '../../components/header';
import Sidebar from '../../components/sidebar';
import Footer from '../../components/footer';
import { RouteTemplate } from './routeTemplate';
import jsPDF from "jspdf";
import Logo from "../../images/logo.png";
import autoTable from "jspdf-autotable";

function App() {

    const [zoneData, setZoneData] = useState([]);
    const templateRef = useRef(null);

    const companyData = {
        companyName: "TRUCOO DAIRY PRODUCTS PRIVATE LIMITED",
        companyAddress1: "C201, SK Hill view Apartment",
        companyAddress2: "Rainbow Enclave",
        companyLocation: "Sugunapuram Myilkal",
        companyCity: "Coimbatore",
        companyState: "Tamil Nadu",
        companyZip: "641008",
        companyPhone: "+91 81900 03400",
        companyEmail: "cbeoffice@trucoo.in",
        companyGst: "33AAKCT9681P1ZC",
        ts: "Sample Terms and Conditions",
        code: "33",
    };

    const getZone = async () => {
        try {
            const response = await axios.get('https://api.trucoo.in/zone/', {
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-KEY': 'erpTrucoo'
                }
            });
            //console.log(response.data);
            if(response.data.status === 'success'){
                setZoneData(response.data.data);
            }
        } catch (error) {
            console.error("Error:", error.response || error.message);
        }
    };


    useEffect(() => {
        getZone();
    },[]);


const downloadPDF = () => {
  const pdf = new jsPDF("p", "mm", "a4");

  // -------- HEADER SECTION --------
  const addHeader = () => {
    // Logo
    pdf.addImage(Logo, "PNG", 10, 10, 30, 15); // (image, type, x, y, width, height)

    // Company Details
    pdf.setFontSize(11);
    pdf.setFont("helvetica", "bold");
    pdf.text(companyData.companyName || "", 210 - 10, 15, { align: "right" });

    pdf.setFontSize(9);
    pdf.setFont("helvetica", "normal");

    const rightText = [
      `${companyData.companyAddress1}, ${companyData.companyAddress2}`,
      `${companyData.companyLocation}, ${companyData.companyCity} - ${companyData.companyZip}`,
      `GSTIN : ${companyData.companyGst}   |   State : ${companyData.companyState}   |   Code : ${companyData.code}`,
      `Phone : ${companyData.companyPhone}   |   Email : ${companyData.companyEmail}`,
    ];

    rightText.forEach((line, i) => {
      pdf.text(line, 210 - 10, 22 + i * 5, { align: "right" });
    });

    // Divider line
    pdf.setLineWidth(0.3);
    pdf.line(10, 42, 200, 42);
  };

  addHeader();

  // -------- TABLE BUILDING --------
  const tableBody = zoneData.map((data, index) => {
    const routeNames = data.route?.map(r => r.route).join("\n") || "";
    const placeNames = data.route
      ?.flatMap(r => r.place?.map(p => p.location))
      .join(", ") || "";

    return [
      index + 1,
      data.zone,
      routeNames,
      placeNames,
    ];
  });

  autoTable(pdf, {
    startY: 48, // BELOW HEADER
    head: [["S.No", "Zone", "Route", "Place"]],
    body: tableBody,
    styles: {
      fontSize: 8,
      cellPadding: 2,
      lineWidth: 0.2,
    },
    headStyles: {
      fillColor: [92, 92, 92],
      fontSize: 9,
      lineWidth: 0.3,
    },
    columnStyles: {
      0: { cellWidth: 13 },
      1: { cellWidth: 30 },
      2: { cellWidth: 55 },
      3: { cellWidth: 90 },
    },
    margin: { left: 10, right: 10 },
    didDrawPage: () => {
      addHeader(); // Re-add header for each page
    },
  });

  pdf.save("route-data.pdf");
};



return(
<>
    <Header />
    <Sidebar />

    <div class="content-wrapper">
        <div class="container-full">
        
            <section class="content">
            <div class="box">
                <div class="box-header with-border">
                  <h4 class="box-title">Route Data</h4>
                  <p class="mb-0 box-subtitle">Routes & Locations</p>
                  <button onClick={downloadPDF} style={{float: 'right', marginTop: '-50px'}} className='btn btn-warning'>Download</button>
                </div>
                
                <div class="box-body">
                    <div class="row">
                       
						<div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-12">
                           
                            <div class="box">
							    <div class="box-body">
                                     <RouteTemplate ref={templateRef} routeData={zoneData} />
                                    {/* <div class="table-responsive">
                                        <table id="example" class="table-sm text-fade table-bordered table-hover display nowrap margin-top-10 w-p100">
                                            <thead>
                                                <tr class="text-dark">
                                                    <th>S.No</th>
                                                    <th>Zone</th>
                                                    <th>Route</th>
                                                    <th>Locations</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {zoneData.length > 0 ? zoneData.map((data, index) =>
                                                <tr key={index}>
                                                    <td class="text-dark">{index+1}</td>
                                                    <td class="text-dark">{data.zone}</td>
                                                    <td>
                                                        {data?.route?.map(routes =>
                                                            <p>{routes.route}</p>
                                                        )}
                                                    </td>
                                                    <td>
                                                        {data.route?.map(routes =>
                                                            routes?.place?.map(place => 
                                                                <p>{place.location}</p>
                                                            )
                                                        )}
                                                    </td>
                                                    
                                                </tr>
                                                ):(
                                                    <tr>
                                                        <td colSpan={3} class="text-center">No Route Data</td>
                                                    </tr>
                                                )}
                                                
                                            </tbody>	
                                        </table>
                                    </div>    */}
                                </div>
                            </div>
                        </div>

                        {/* <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-12">
                            <div class="box">
							    <div class="box-body">
                                    <div class="table-responsive">
                                        <table id="example" class="table text-fade table-bordered table-hover display nowrap margin-top-10 w-p100">
                                            <thead>
                                                <tr class="text-dark">
                                                    <th>S.No</th>
                                                    <th>Zone</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {zoneData.length > 0 ? zoneData?.map((data, index) =>
                                                <tr key={index}>
                                                    <td class="text-dark">{index+1}</td>
                                                    <td>{data.zone}</td>
                                                </tr>
                                                ):(
                                                    <tr>
                                                        <td colSpan={2} class="text-center">No Zone Data</td>
                                                    </tr>
                                                )}
                                                
                                            </tbody>	
                                        </table>
                                    </div>   
                                </div>
                            </div>
                        </div> */}

                    </div>
                </div>
              </div>
            </section>
        </div>
    </div>

    <Footer />
</>
);
}

export default App;